__turbopack_context__.v({
  "membership-dues-table": "membership-dues-module-scss-module__OjXDhW__membership-dues-table",
  "wrapper": "membership-dues-module-scss-module__OjXDhW__wrapper",
  "wrapper__description": "membership-dues-module-scss-module__OjXDhW__wrapper__description",
  "wrapper__label": "membership-dues-module-scss-module__OjXDhW__wrapper__label",
});
